export enum ExportQueryType {
	LIBRARY = 'LIBRARY',
	MULTISELECT = 'MULTISELECT',
	SEARCH = 'SEARCH'
}

export enum DownloadHttpMethod {
	GET = 'get',
	POST = 'post'
}

export enum FileSelectionMethod {
	ButtonClick = 'ButtonClick',
	DragNDrop = 'Drag&Drop'
}
